@if (isRegisterPage() | async) {
  @if (showloader) {
    <div class="loading" >
      <div class="loading_txt">
        <div class="load_txt">Loading</div>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  }
  <!------Business Details Section starts here------>
  <div [style.display]="isVisibleBussiness ? 'block' : 'none'" >
    <form  class="registration col-xs-12 no-padding"   [formGroup]="orgAddress">
      <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 registration_leftside no-padding-right">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 registration_nagivation no-padding">
          <div class="registration_nagivationPart" id="registration_nagivationPart1">
            <div class="registration_nagivationNo">
              <div class="registration_nagivationtick reg_Navigationtick"><img src="assets\images\greentick.png" alt=""></div>
            </div>
            <div class="registration_nagivationName">{{'progresslabel.userProfile' | cxTranslate}}</div>
          </div>
          <div class="registration_nagivationPart" id="registration_nagivationPart2">
            <div class="registration_nagivationNo">
              <div class="registration_nagivationNumeric">2</div>
            </div>
            <div class="registration_nagivationName active">{{'progresslabel.businessDetails' | cxTranslate}}</div>
          </div>
          <div class="registration_nagivationPart" id="registration_nagivationPart3">
            <div class="registration_nagivationNo">
              <div class="registration_nagivationNumeric">3</div>
            </div>
            <div class="registration_nagivationName inactive">{{'progresslabel.contactAddress' | cxTranslate}}<ul>
              <li>{{'progresslabel.billinginformation' | cxTranslate}}</li>
              <li>{{'progresslabel.payingInformation' | cxTranslate}}</li>
              <li>{{'progresslabel.shippingLocation' | cxTranslate}}</li>
            </ul>
          </div>
        </div>
        <div class="registration_nagivationPart" id="registration_nagivationPart4">
          <div class="registration_nagivationNo">
            <div class="registration_nagivationNumeric">4</div>
          </div>
          <div class="registration_nagivationName inactive">{{'progresslabel.reviewConfirm' | cxTranslate}}</div>
        </div>
      </div>
    </div>
    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 registration_rightside no-padding-left">
      <div class="registration_help">
        {{'bussinessDetails.Havingtrouble' | cxTranslate}} &nbsp;<a routerLink="/help-and-faq"  class="showPopupclick"><span>{{'bussinessDetails.WeCanHelp' | cxTranslate}}</span><span class="global_blackarrow"></span></a>
      </div>
      <section class="registration_business registrationFlow" id="registration_section1">
        <h1 class="registration_label padding-B10 new_header_register">{{'progresslabel.businessDetails' | cxTranslate}}</h1>
        <div class="registration_text1 padding-B10">{{'bussinessDetails.content1' | cxTranslate}}</div>
        <div class="registration_text2">{{'bussinessDetails.content2' | cxTranslate}}</div>
        <div class="registration_existing padding-B20"><a (click)="openregistrationExitpopup()" target="_self" class="showPopupclick">{{'bussinessDetails.content3' | cxTranslate}} <div class="global_blackarrow"></div></a></div>
        <div class="padding-R15">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
            <label class="registration_inputLabel" for="business-orgname">{{'bussinessDetails.CompanyName' | cxTranslate}}</label>
            <input class="registration_input form-control" id="orgName" formControlName="orgName">
            @if (orgAddress.controls['orgName'].invalid && (isFormSubmitted_bussiness || orgAddress.controls['orgName'].touched || orgAddress.controls['orgName'].dirty)) {
              <div class="text-danger">
                <i class="fa-solid fa-circle-exclamation"></i>
                @if (orgAddress.controls['orgName'].errors?.['required']) {
                  <label class="error help-block">{{'bussinessDetails.CompanyNameError1' | cxTranslate}}</label>
                }
                @if (orgAddress.controls['orgName'].errors?.['pattern']) {
                  <label class="error help-block">{{'bussinessDetails.CompanyNameError2' | cxTranslate}}</label>
                }
              </div>
            }
          </div>
          <div class="clearboth"></div>
        </div>
        <div class="padding-R15">
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
            <label class="registration_inputLabel" for="business-dunnumber">{{'bussinessDetails.DUNSNumber' | cxTranslate}}</label>
            <input class="registration_input form-control" id="duns" formControlName="duns" autocomplete="off" >
            @if (orgAddress.controls['duns'].invalid && (isFormSubmitted_bussiness || orgAddress.controls['duns'].touched || orgAddress.controls['duns'].dirty)) {
              <div class="text-danger">
                <i class="fa-solid fa-circle-exclamation"></i>
                @if (orgAddress.controls['duns'].errors?.['pattern']) {
                  <label class="error help-block">{{'bussinessDetails.DUNSNumberError1' | cxTranslate}}</label>
                }
                @if (!orgAddress.controls['duns'].errors?.['pattern']) {
                  <div>
                    @if (orgAddress.controls['duns'].errors?.['minlength']) {
                      <label class="error help-block">{{'bussinessDetails.DUNSNumberError2' | cxTranslate}}</label>
                    }
                    @if (orgAddress.controls['duns'].errors?.['maxlength']) {
                      <label class="error help-block">{{'bussinessDetails.DUNSNumberError3' | cxTranslate}}</label>
                    }
                  </div>
                }
              </div>
            }
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding-right margin-B20 registration_parent form-group ">
            <label class="registration_inputLabel gln_field " for="business-gln">{{'bussinessDetails.GLN' | cxTranslate}}&nbsp;<i class="fa-regular fa-circle-question locations_qm locations_tooltip"><span class="locations_tooltiptext" [innerHTML]="'bussinessDetails.GLNTooltips' | cxTranslate"></span></i></label>
            <p-inputMask class="registration_input form-control" autoClear="false"   mask="9999999.99999.9" pattern="\d\d\d\d\d\d\d\.\d\d\d\d\d\.\d" id="globalLocationNumber" formControlName="globalLocationNumber" />
            @if (orgAddress.controls['globalLocationNumber'].invalid && (isFormSubmitted_bussiness || orgAddress.controls['globalLocationNumber'].touched || orgAddress.controls['globalLocationNumber'].dirty)) {
              <div class="text-danger">
                <i class="fa-solid fa-circle-exclamation"></i>
                @if (orgAddress.controls['globalLocationNumber'].errors?.['pattern']) {
                  <label class="error help-block">{{'bussinessDetails.GLNError1' | cxTranslate}}</label>
                }
              </div>
            }
          </div>
        </div>
        <!-- Membership for registration changes -->
        <div class="clearboth"></div>
        <div class="registration_membershiptxt margin-B10">{{'bussinessDetails.Membershiptextgrp' | cxTranslate}}&nbsp;<i class="fa-regular fa-circle-question locations_qm locations_tooltip" style="font-size: 14px;"><span class="locations_tooltiptext" [innerHTML]="'bussinessDetails.MembershipTooltips' | cxTranslate"></span></i></div>
        <div class="padding-R15">
          <fieldset id="group-1">
            <div class="col-lg-2 col-md-2 col-sm-4 col-xs-6 no-padding-left registration_parent spcl-radio" style="padding-bottom: 0px !important;">
              <label class="radio-button">
                <input
                  type="radio"
                  class="registration_radio"
                  formControlName="memberBuyingGrp"
                  [value]="true"
                  />
                  <span class="radio-button__control"
                                  [ngClass]="{
                                        'radio-error': 
                                          orgAddress.get('memberBuyingGrp')?.invalid &&
                                          (isFormSubmitted_bussiness ||
                                           orgAddress.get('memberBuyingGrp')?.touched ||
                                           orgAddress.get('memberBuyingGrp')?.dirty)
                                      }"
                  ></span>
                </label>
                <label class="registration_checkboxLabel"> {{'bussinessDetails.radiobtnlevel1' | cxTranslate}}</label>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-4 col-xs-6 no-padding-right registration_parent spcl-radio" style="padding-bottom: 0px !important;">
                <label class="radio-button">
                  <input
                    type="radio"
                    class="registration_radio"
                    formControlName="memberBuyingGrp"
                    [value]="false"
                    />
                    <span class="radio-button__control"
                                  [ngClass]="{
                                        'radio-error': 
                                          orgAddress.get('memberBuyingGrp')?.invalid &&
                                          (isFormSubmitted_bussiness ||
                                           orgAddress.get('memberBuyingGrp')?.touched ||
                                           orgAddress.get('memberBuyingGrp')?.dirty)
                                      }"
                    ></span>
                  </label>
                  <label class="registration_checkboxLabel">{{'bussinessDetails.radiobtnlevel2' | cxTranslate}}</label>
                </div>
                <div class="clearboth"></div>
                <!-- ✅ Validation Error -->
                @if (
                  orgAddress.get('memberBuyingGrp')?.invalid &&
                  (isFormSubmitted_bussiness ||
                  orgAddress.get('memberBuyingGrp')?.touched ||
                  orgAddress.get('memberBuyingGrp')?.dirty)) {
                  <div
                    class="text-danger"
                    >
                    <!-- <i class="fa-solid fa-circle-exclamation"></i> -->
                    <label class="error help-block">
                      {{'bussinessDetails.RadiobtnError' | cxTranslate}}
                    </label>
                  </div>
                }
              </fieldset>
            </div>
            @if (isDivVisiblemembership) {
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-padding registration_parent form-group" id="bill-accemail">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding registration_parent form-group">
                  <label class="registration_inputLabel" for="business-BuyingGuide">
                    {{ 'bussinessDetails.BuyingGuide' | cxTranslate }}
                  </label>
                  <input
                    class="registration_input form-control"
                    id="membership"
                    formControlName="membership"
                    />
                    <!-- ✅ Validation Message -->
                    @if (
                      orgAddress.get('membership')?.invalid &&
                      (isFormSubmitted_bussiness ||
                      orgAddress.get('membership')?.touched ||
                      orgAddress.get('membership')?.dirty)) {
                      <div
                        class="text-danger"
                        >
                        <i class="fa-solid fa-circle-exclamation"></i>
                        <label class="error help-block">
                          {{'bussinessDetails.MembershipError' | cxTranslate}}
                        </label>
                      </div>
                    }
                  </div>
                </div>
              }
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding margin-B20 registration_address form-group">
                <label class="registration_inputLabel" for="business-lookup">{{'formLevel.AddressLookup' | cxTranslate}}</label>
                <input class="registration_input form-control" id="businesslookup"  name="businesslookup"  >
                <span class="glyphicon glyphicon-search form-control-feedback"></span>
              </div>
              <div class="padding-R15">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
                  <label class="registration_inputLabel " for="business-address1">{{'formLevel.AddressLine1' | cxTranslate}}</label>
                  <input class="registration_input form-control" name="line1" id="addressLine1" formControlName="line1" autocomplete="off" >
                  @if (orgAddress.controls['line1'].invalid && (isFormSubmitted_bussiness || orgAddress.controls['line1'].touched || orgAddress.controls['line1'].dirty)) {
                    <div class="text-danger"  >
                      <i class="fa-solid fa-circle-exclamation"></i>
                      @if (orgAddress.controls['line1'].errors?.['required']) {
                        <label class="error help-block">{{'formLevel.AddressLine1Error' | cxTranslate}}</label>
                      }
                    </div>
                  }
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding-right margin-B20 registration_parent form-group">
                  <label class="registration_inputLabel " for="business-address2">{{'formLevel.AddressLine2' | cxTranslate}}</label>
                  <input class="registration_input form-control" name="line2"  id="addressLine2" formControlName="line2" >
                </div>
                <div class="clearboth"></div>
              </div>
              <div class="padding-R15">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
                  <label class="registration_inputLabel " for="business-city">{{'formLevel.City' | cxTranslate}}</label>
                  <input class="registration_input form-control"  id="city" name="city" formControlName="city" >
                  @if (orgAddress.controls['city'].invalid && (isFormSubmitted_bussiness || orgAddress.controls['city'].touched || orgAddress.controls['city'].dirty)) {
                    <div class="text-danger" >
                      <i class="fa-solid fa-circle-exclamation"></i>
                      @if (orgAddress.controls['city'].errors?.['required']) {
                        <label class="error help-block">{{'formLevel.CityError' | cxTranslate}}</label>
                      }
                    </div>
                  }
                </div>
                <div class="col-lg-2 col-md-2 col-sm-6 col-xs-6 no-padding-right margin-B20 registration_mob form-group">
                  <label class="registration_inputLabel " for="business-state">{{'formLevel.State' | cxTranslate}}</label>
                  <select class="registration_state form-control"  id="state" name="state" formControlName="state">
                    @for (item of stateList; track item) {
                      <option selected="selected" [value]="item.value">{{ item.label }}</option>
                    }
                  </select>
                  @if (orgAddress.controls['state'].invalid && (isFormSubmitted_bussiness || orgAddress.controls['state'].touched || orgAddress.controls['state'].dirty)) {
                    <div class="text-danger" >
                      <i class="fa-solid fa-circle-exclamation"></i>
                      @if (orgAddress.controls['state'].errors?.['required']) {
                        <label class="error help-block">{{'formLevel.StateError' | cxTranslate}}</label>
                      }
                    </div>
                  }
                </div>
                <div class="col-lg-4 col-md-4 col-sm-6 col-xs-6 no-padding-right margin-B20 form-group">
                  <label class="registration_inputLabel" for="business-zipcode">{{'formLevel.ZipCode' | cxTranslate}}</label>
                  <input class="registration_input form-control"  id="zipCode" name="postalCode" formControlName="postalCode">
                  @if (orgAddress.controls['postalCode'].invalid && (isFormSubmitted_bussiness || orgAddress.controls['postalCode'].touched || orgAddress.controls['postalCode'].dirty)) {
                    <div class="text-danger" >
                      <i class="fa-solid fa-circle-exclamation"></i>
                      @if (orgAddress.controls['postalCode'].errors?.['required']) {
                        <label class="error help-block">{{'formLevel.ZipCodeUSError1' | cxTranslate}}</label>
                      }
                      @if (orgAddress.controls['postalCode'].errors?.['pattern']) {
                        <label class="error help-block">{{'formLevel.ZipCodeUSError1' | cxTranslate}}</label>
                      }
                    </div>
                  }
                </div>
                <div class="clearboth"></div>
                @if (regAutorollOverData | async; as data){
                  @if(isPreBook){
                  <div class="auto_roleover_bg">
                    <span>{{data.text2}}</span>
                    <p>{{data.paragraphcontent}}{{data.content}}</p>
                    <div class="consent">
                      <label class="checkbox-button">
                        <input type="checkbox" class="registration_checkbox" [checked]="orgAddress.get('ARRconsent')?.value" formControlName="ARRconsent">
                        <span class="checkbox-button__control"></span>
                      </label>
                      {{'formLevel.autorolloverconsent' | cxTranslate}} (<a href='/terms-conditions-sales-2026-2027' target="_blank">{{'formLevel.TermsConditionSale' | cxTranslate}}</a>)
                    </div>
                  </div>
                }
                  <!-- //new changes -->
                  <div [innerHTML]="data.h2content">
                  </div>
                  <div class="pdf-container">
                    <div class="terms_Conditions_Iframe" #termsIframe>
                      <iframe class="pdf desktoppdf hidden-xs hidden-sm" [src]="pdfUrl" width="100%" frameborder="0"
                      scrolling="no"></iframe>
                      <div class="terms-checkbox">
                        <label>
                          <input type="checkbox" [(ngModel)]="termsAccepted" [ngModelOptions]="{standalone:true}" (change)="onTermsChange()"
                            class="rollover_Checkbox" #termsCheckbox />
                            <span class="checkbox-button__control"></span>
                          </label>
                          <div class="terms_And_Conditions" [innerHTML]="data.text1"></div>
                        </div>
                      </div>
                    </div>
                    @if (showError) {
                      <p class="error_Msg">{{data.title}}</p>
                    }
                  }
                </div>
                <button type="button" (click)="onSubmit_bussiness()" class="registration_save active" id="registration_save">{{'formLevel.SaveandContinue' | cxTranslate}}</button>
              </section>
            </div>
          </form>
        </div>
        <!------Business Details Section Ends here------>
        <!------Billing  section Starts here------>
        <div [style.display]="isVisibleBilling ? 'block' : 'none'" >
          <form  class="registration col-xs-12 no-padding" novalidate [formGroup]="billingAddress">
            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 registration_leftside no-padding-right">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 registration_nagivation no-padding">
                <div class="registration_nagivationPart" id="registration_nagivationPart1">
                  <div class="registration_nagivationNo">
                    <div class="registration_nagivationtick billing_Reg_Nagivationtick"><img src="assets\images\greentick.png" alt=""></div>
                  </div>
                  <div class="registration_nagivationName">{{'progresslabel.userProfile' | cxTranslate}}</div>
                </div>
                <div class="registration_nagivationPart" id="registration_nagivationPart2">
                  <div class="registration_nagivationNo">
                    <div class="registration_nagivationNumeric registration_NagivationNumericPart2">2</div>
                    <div class="registration_nagivationtick billing_Reg_Nagivationtick_Part2"><img src="assets\images\greentick.png" alt=""></div>
                  </div>
                  <div class="registration_nagivationName">{{'progresslabel.businessDetails' | cxTranslate}}</div>
                </div>
                <div class="registration_nagivationPart" id="registration_nagivationPart3">
                  <div class="registration_nagivationNo">
                    <div class="registration_nagivationNumeric">3</div>
                  </div>
                  <div class="registration_nagivationName active">{{'progresslabel.contactAddress' | cxTranslate}}<ul>
                    <li class="active billing_Info_Li">{{'progresslabel.billinginformation' | cxTranslate}}</li>
                    <li class="payment_Info_Li">{{'progresslabel.payingInformation' | cxTranslate}}</li>
                    <li class="shiiping_Location_Li">{{'progresslabel.shippingLocation' | cxTranslate}}</li>
                  </ul>
                </div>
              </div>
              <div class="registration_nagivationPart" id="registration_nagivationPart4">
                <div class="registration_nagivationNo">
                  <div class="registration_nagivationNumeric">4</div>
                </div>
                <div class="registration_nagivationName inactive">{{'progresslabel.reviewConfirm' | cxTranslate}}</div>
              </div>
            </div>
          </div>
          <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 registration_rightside no-padding-left">
            <div class=" registration_help">
              {{'bussinessDetails.Havingtrouble' | cxTranslate}} &nbsp;<a routerLink="/help-and-faq"  class="showPopupclick"><span>{{'bussinessDetails.WeCanHelp' | cxTranslate}}</span><span class="global_blackarrow"></span></a>
            </div>
            <section class="registration_billing registrationFlow" id="registration_section2">
              <div class="registration_label padding-B10">{{'progresslabel.billinginformation' | cxTranslate}}</div>
              <div class="registration_text1 padding-B10">{{'billinginfo.content1' | cxTranslate}}</div>
              <div class="registration_text2">{{'bussinessDetails.content2' | cxTranslate}}</div>
              <div class="registration_contact padding-B20">{{'billinginfo.BillingContact' | cxTranslate}}</div>
              <div class="padding-R15">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
                  <label class="registration_inputLabel" for="billing-firstname">{{'formLevel.firstName' | cxTranslate}}</label>
                  <input class="registration_input form-control" id="billing-firstname"  autocomplete="off" formControlName="firstName" >
                  @if (billingAddress.controls['firstName'].invalid && (isFormSubmitted_billing || billingAddress.controls['firstName'].touched || billingAddress.controls['firstName'].dirty)) {
                    <div class="text-danger">
                      <i class="fa-solid fa-circle-exclamation"></i>
                      @if (billingAddress.controls['firstName'].errors?.['required']) {
                        <label class="error help-block">{{'formLevel.firstNameError1' | cxTranslate}}</label>
                      }
                      @if (billingAddress.controls['firstName'].errors?.['pattern']) {
                        <label class="error help-block">{{'formLevel.firstNameError2' | cxTranslate}}</label>
                      }
                    </div>
                  }
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding-right margin-B20 registration_parent form-group">
                  <label class="registration_inputLabel" for="billing-lastname">{{'formLevel.lastName' | cxTranslate}}</label>
                  <input class="registration_input form-control" id="billing-lastname"  autocomplete="off" formControlName="lastName" >
                  @if (billingAddress.controls['lastName'].invalid && (isFormSubmitted_billing || billingAddress.controls['lastName'].touched || billingAddress.controls['lastName'].dirty)) {
                    <div class="text-danger">
                      <i class="fa-solid fa-circle-exclamation"></i>
                      @if (billingAddress.controls['lastName'].errors?.['required']) {
                        <label class="error help-block">{{'formLevel.lastNameError1' | cxTranslate}}</label>
                      }
                      @if (billingAddress.controls['lastName'].errors?.['pattern']) {
                        <label class="error help-block">{{'formLevel.lastNameError2' | cxTranslate}}</label>
                      }
                    </div>
                  }
                </div>
                <div class="clearboth"></div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
                <label class="registration_inputLabel" for="billing-email">{{'formLevel.EmailAddress' | cxTranslate}}</label>
                <input class="registration_input form-control" id="billing-email"  autocomplete="off" formControlName="email" >
                @if (billingAddress.controls['email'].invalid && (isFormSubmitted_billing || billingAddress.controls['email'].touched || billingAddress.controls['email'].dirty)) {
                  <div class="text-danger">
                    <i class="fa-solid fa-circle-exclamation"></i>
                    @if (billingAddress.controls['email'].errors?.['required']) {
                      <label class="error help-block">{{'formLevel.EmailAddressError1' | cxTranslate}}</label>
                    }
                    @if (billingAddress.controls['email'].errors?.['pattern']) {
                      <label class="error help-block">{{'formLevel.EmailAddressError1' | cxTranslate}}</label>
                    }
                  </div>
                }
              </div>
              <div class="clearboth"></div>
              <div class="padding-R15">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
                  <label class="registration_inputLabel" for="billing-phone">{{'formLevel.PhoneNumber' | cxTranslate}}</label>
                  <p-inputMask class="registration_input form-control" autocomplete="off" autoClear="false"  mask="(999) 999-9999" pattern="^(\([2-9]([02-9]\d|1[02-9])\)|[2-9]([02-9]\d|1[02-9])) ?[2-9]\d{2}-?\d{4}$"  formControlName="phone"   />
                  @if (billingAddress.controls['phone'].invalid && (isFormSubmitted_billing || billingAddress.controls['phone'].touched || billingAddress.controls['phone'].dirty)) {
                    <div class="text-danger">
                      <i class="fa-solid fa-circle-exclamation"></i>
                      @if (billingAddress.controls['phone'].errors?.['required']) {
                        <label class="error help-block">{{'formLevel.PhoneNumberError1' | cxTranslate}}</label>
                      }
                      @if (billingAddress.controls['phone'].errors?.['pattern']) {
                        <label class="error help-block">{{'formLevel.PhoneNumberError1' | cxTranslate}}</label>
                      }
                    </div>
                  }
                </div>
                <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding-right margin-B20 registration_parent form-group">
                  <label class="registration_inputLabel" for="billing-extn">{{'formLevel.phnext' | cxTranslate}}</label>
                  <input class="registration_input form-control" formControlName="phoneExt" (keypress)="allowOnlyNumbers($event)" maxlength="4" autocomplete="off">
                </div>
                <div class="clearboth"></div>
              </div>
              <div class="registration_contact padding-B20">{{'billinginfo.BillingAddress' | cxTranslate}}</div>
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
                <label class="registration_inputLabel" for="billing-orgname">{{'formLevel.OrganizationName' | cxTranslate}}</label>
                <input class="registration_input form-control" formControlName="orgName"  autocomplete="off" >
                @if (billingAddress.controls['orgName'].invalid && (isFormSubmitted_billing || billingAddress.controls['orgName'].touched || billingAddress.controls['orgName'].dirty)) {
                  <div class="text-danger">
                    <i class="fa-solid fa-circle-exclamation"></i>
                    @if (billingAddress.controls['orgName'].errors?.['required']) {
                      <label class="error help-block">{{'formLevel.OrganizationNameError1' | cxTranslate}}</label>
                    }
                    @if (billingAddress.controls['orgName'].errors?.['pattern']) {
                      <label class="error help-block">{{'formLevel.OrganizationNameError2' | cxTranslate}}</label>
                    }
                  </div>
                }
              </div>
              <div class="clearboth"></div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding-left margin-B30 registration_address form-group">
                <label class="registration_inputLabel" for="billing-lookup">{{'formLevel.AddressLookup' | cxTranslate}}</label>
                <input class="registration_input form-control"  id="billinglookup"   name="billinglookup" >
                <span class="glyphicon glyphicon-search form-control-feedback"></span>
              </div>
              <div class="padding-R15">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
                  <label class="registration_inputLabel" for="billing-address1">{{'formLevel.AddressLine1' | cxTranslate}}</label>
                  <input class="registration_input form-control" id="line1" name="addressLine1_billing" formControlName="line1"  autocomplete="off" >
                  @if (billingAddress.controls['line1'].invalid && (isFormSubmitted_billing || billingAddress.controls['line1'].touched || billingAddress.controls['line1'].dirty)) {
                    <div class="text-danger" >
                      <i class="fa-solid fa-circle-exclamation"></i>
                      @if (billingAddress.controls['line1'].errors?.['required']) {
                        <label class="error help-block">{{'formLevel.AddressLine1Error' | cxTranslate}}</label>
                      }
                    </div>
                  }
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding-right margin-B20 registration_parent form-group">
                  <label class="registration_inputLabel" for="billing-address2">{{'formLevel.AddressLine2' | cxTranslate}}</label>
                  <input class="registration_input form-control" id="line2" name="addressLine2_billing" formControlName="line2"  autocomplete="off" >
                </div>
                <div class="clearboth"></div>
              </div>
              <div class="padding-R15">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
                  <label class="registration_inputLabel" for="billing-city">{{'formLevel.City' | cxTranslate}}</label>
                  <input class="registration_input form-control" id="city" name="city_billing"  autocomplete="off" formControlName="city">
                  @if (billingAddress.controls['city'].invalid && (isFormSubmitted_billing || billingAddress.controls['city'].touched || billingAddress.controls['city'].dirty)) {
                    <div class="text-danger" >
                      <i class="fa-solid fa-circle-exclamation"></i>
                      @if (billingAddress.controls['city'].errors?.['required']) {
                        <label class="error help-block">{{'formLevel.CityError' | cxTranslate}}</label>
                      }
                    </div>
                  }
                </div>
                <div class="col-lg-2 col-md-2 col-sm-6 col-xs-6 no-padding-right margin-B20 registration_mob form-group">
                  <label class="registration_inputLabel " for="billing-state">{{'formLevel.State' | cxTranslate}}</label>
                  <select class="registration_state form-control" id="state" formControlName="state" name="state_billing">
                    @for (item of stateList; track item) {
                      <option selected="selected" [value]="item.value">{{ item.label }}</option>
                    }
                  </select>
                  @if (billingAddress.controls['state'].invalid && (isFormSubmitted_billing || billingAddress.controls['state'].touched || billingAddress.controls['state'].dirty)) {
                    <div class="text-danger" >
                      <i class="fa-solid fa-circle-exclamation"></i>
                      @if (billingAddress.controls['state'].errors?.['required']) {
                        <label class="error help-block">{{'formLevel.StateError' | cxTranslate}}</label>
                      }
                    </div>
                  }
                </div>
                <div class="col-lg-4 col-md-4 col-sm-6 col-xs-6 no-padding-right margin-B20 form-group">
                  <label class="registration_inputLabel" for="billing-zipcode">{{'formLevel.ZipCode' | cxTranslate}}</label>
                  <input class="registration_input form-control" id="postalCode" name="zipCode_billing" formControlName="postalCode" autocomplete="off" >
                  @if (billingAddress.controls['postalCode'].invalid && (isFormSubmitted_billing || billingAddress.controls['postalCode'].touched || billingAddress.controls['postalCode'].dirty)) {
                    <div class="text-danger" >
                      <i class="fa-solid fa-circle-exclamation"></i>
                      @if (billingAddress.controls['postalCode'].errors?.['required']) {
                        <label class="error help-block">{{'formLevel.ZipCodeUSError1' | cxTranslate}}</label>
                      }
                      @if (billingAddress.controls['postalCode'].errors?.['pattern']) {
                        <label class="error help-block">{{'formLevel.ZipCodeUSError1' | cxTranslate}} </label>
                      }
                    </div>
                  }
                </div>
                <div class="clearboth"></div>
              </div>
              <div class="registration_contact padding-B20">{{'formLevel.CommunicationPreferences' | cxTranslate}}</div>
              <div class="padding-R15">
                <div class="margin-B20 registration_reviewCheckbox registration_parent registration_checkparent">
                  <label class="checkbox-button">
                    <input type="checkbox" class="registration_checkbox" (change)="onCheckboxChange($event)">
                    <span class="checkbox-button__control"></span>
                  </label>
                  <label class="registration_checkboxLabel">{{'billinginfo.checkboxLabel1' | cxTranslate}} &nbsp;&nbsp;<span [attr.tooltip]="tooltipText" tooltip-position="buttom" ><i class="fa fa-question-circle-o" ></i></span></label>
                  <div class="clearboth"></div>
                </div>
                <div class="margin-B20 registration_parent registration_reviewCheckbox">
                  <label class="checkbox-button">
                    <input type="checkbox" class="registration_checkbox" formControlName="isSameAsShippingAddress" (change)="onCheckboxCopytoShipping($event)">
                    <span class="checkbox-button__control"></span>
                  </label>
                  <label class="registration_checkboxLabel">{{'billinginfo.Shiptothislocation' | cxTranslate}} &nbsp;&nbsp;<span [attr.tooltip]="tooltipText2" tooltip-position="buttom" ><i class="fa fa-question-circle-o" ></i></span></label>
                  <div class="clearboth"></div>
                </div>
              </div>
              <div class="padding-R15 padding-B20 registration_checkQues">{{'billinginfo.Howwouldyoulike' | cxTranslate}}</div>
              <div class="padding-R15">
                <fieldset id="group1">
                  <div class="col-lg-2 col-md-2 col-sm-4 col-xs-6 no-padding-left margin-B10 registration_parent">
                    <label class="radio-button">
                      <input type="radio" class="registration_radio" [checked]="billingAddress.get('optNotifyAcctStmtEmail')?.value" formControlName="confAcctStmtEmail" value="email"  (click)="toggleDiv(true)" >
                      <span class="radio-button__control"></span>
                    </label>
                    <label class="registration_checkboxLabel">{{'formLevel.Emailonly' | cxTranslate}}</label>
                    <div class="clearboth"></div>
                  </div>
                  <div class="col-lg-2 col-md-2 col-sm-4 col-xs-6 no-padding-right margin-B10 registration_parent">
                    <label class="radio-button">
                      <input type="radio"  class="registration_radio" formControlName="confAcctStmtEmail" [checked]="!billingAddress.get('optNotifyAcctStmtEmail')?.value" value="mail" (click)="toggleDiv(false)" id="bill-accountType_M" >
                      <span class="radio-button__control"></span>
                    </label>
                    <label class="registration_checkboxLabel">{{'formLevel.Bymail' | cxTranslate}}</label>
                    <div class="clearboth"></div>
                  </div>
                  <div class="clearboth"></div>
                </fieldset>
              </div>
              @if (isDivVisible) {
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-padding margin-B20 registration_parent form-group" id="bill-accemail">
                  <label class="registration_inputLabel" for="billing-accountemail">{{'formLevel.EmailAddress' | cxTranslate}}</label>
                  <input class="registration_input form-control" formControlName="acctStmtEmail" autocomplete="off">
                  @if (billingAddress.controls['acctStmtEmail'].invalid && (isFormSubmitted_billing || billingAddress.controls['acctStmtEmail'].touched || billingAddress.controls['acctStmtEmail'].dirty)) {
                    <div class="text-danger">
                      <i class="fa-solid fa-circle-exclamation"></i>
                      @if (billingAddress.controls['acctStmtEmail'].errors?.['required']) {
                        <label class="error help-block">{{'formLevel.EmailAddressError1' | cxTranslate}}</label>
                      }
                      @if (billingAddress.controls['acctStmtEmail'].errors?.['pattern']) {
                        <label class="error help-block">{{'formLevel.EmailAddressError1' | cxTranslate}}</label>
                      }
                    </div>
                  }
                </div>
              }
              <div class="clearboth"></div>
              <div class="padding-R15 padding-B20 registration_checkQues">{{'billinginfo.Howwouldreceiveinvoices' | cxTranslate}}</div>
              <div class="padding-R15">
                <fieldset id="group2">
                  <div class="col-lg-2 col-md-2 col-sm-4 col-xs-6 no-padding-left margin-B10 registration_parent">
                    <label class="radio-button">
                      <input type="radio"  class="registration_radio" formControlName="optNotifyInvoiceEmail" [checked]="billingAddress.get('optNotifyInvoiceEmail')?.value" formControlName="confInvoiceEmail" value="email" (click)="toggleDiv1(true)" >
                      <span class="radio-button__control"></span>
                    </label>
                    <label class="registration_checkboxLabel">{{'formLevel.Emailonly' | cxTranslate}}</label>
                    <div class="clearboth"></div>
                  </div>
                  <div class="col-lg-2 col-md-2 col-sm-4 col-xs-6 no-padding-right margin-B10 registration_parent">
                    <label class="radio-button">
                      <input type="radio"  class="registration_radio" id="bill-invoiceType_M" (click)="toggleDiv1(false)" formControlName="optNotifyInvoiceEmail" [checked]="!billingAddress.get('optNotifyInvoiceEmail')?.value" formControlName="confInvoiceEmail" value="mail" >
                      <span class="radio-button__control"></span>
                    </label>
                    <label class="registration_checkboxLabel">{{'formLevel.Bymail' | cxTranslate}}</label>
                    <div class="clearboth"></div>
                  </div>
                  <div class="clearboth"></div>
                </fieldset>
              </div>
              @if (isDivVisible1) {
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-padding margin-B20 registration_parent form-group">
                  <label class="registration_inputLabel" for="billing-invoiceemail">{{'formLevel.EmailAddress' | cxTranslate}}</label>
                  <input class="registration_input form-control" formControlName="invoiceEmail" autocomplete="off">
                  @if (billingAddress.controls['invoiceEmail'].invalid && (isFormSubmitted_billing || billingAddress.controls['invoiceEmail'].touched || billingAddress.controls['invoiceEmail'].dirty)) {
                    <div class="text-danger">
                      <i class="fa-solid fa-circle-exclamation"></i>
                      @if (billingAddress.controls['invoiceEmail'].errors?.['required']) {
                        <label class="error help-block">{{'formLevel.EmailAddressError1' | cxTranslate}}</label>
                      }
                      @if (billingAddress.controls['invoiceEmail'].errors?.['pattern']) {
                        <label class="error help-block">{{'formLevel.EmailAddressError1' | cxTranslate}}</label>
                      }
                    </div>
                  }
                </div>
              }
              <div class="clearboth"></div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding margin-T20 margin-B20 registration_button">
                <div class="registration_back active" (click)="showBussinessSection()">
                  <div class="global_blackarrow"></div>
                  <span>{{'formLevel.Back' | cxTranslate}}</span>
                  <div class="clearboth"></div>
                </div>
                <button type="button" (click)="onSubmit_billing()"  class="registration_save active" id="registration_save">{{'formLevel.SaveandContinue' | cxTranslate}}</button>
                <div class="clearboth"></div>
              </div>
            </section>
          </div>
        </form>
      </div>
      <!------Billing section Ends here------>
      <!------Paying Information Section Starts here------>
      <div [style.display]="isVisiblePaying ? 'block' : 'none'" >
        <form class="registration col-xs-12 no-padding" novalidate [formGroup]="payerAddress">
          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 registration_leftside no-padding-right">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 registration_nagivation no-padding">
              <div class="registration_nagivationPart" id="registration_nagivationPart1">
                <div class="registration_nagivationNo">
                  <div class="registration_nagivationtick payinfo_Registration_Nagivationtick"><img src="assets\images\greentick.png" alt=""></div>
                </div>
                <div class="registration_nagivationName">{{'progresslabel.userProfile' | cxTranslate}}</div>
              </div>
              <div class="registration_nagivationPart" id="registration_nagivationPart2">
                <div class="registration_nagivationNo">
                  <div class="registration_nagivationNumeric registration_NagivationNumericPart2">2</div>
                  <div class="registration_nagivationtick payInfo_Reg_Nagivationtick_Part2"><img src="assets\images\greentick.png" alt=""></div>
                </div>
                <div class="registration_nagivationName">{{'progresslabel.businessDetails' | cxTranslate}}</div>
              </div>
              <div class="registration_nagivationPart" id="registration_nagivationPart3">
                <div class="registration_nagivationNo">
                  <div class="registration_nagivationNumeric">3</div>
                  <div class="registration_nagivationtick"><img src="assets\images\greentick.png" alt=""></div>
                </div>
                <div class="registration_nagivationName active">{{'progresslabel.contactAddress' | cxTranslate}}<ul>
                  <li class="billing_Info_Li">{{'progresslabel.billinginformation' | cxTranslate}}</li>
                  <li class="active payment_Info_Li">{{'progresslabel.payingInformation' | cxTranslate}}</li>
                  <li class="shiiping_Location_Li">{{'progresslabel.shippingLocation' | cxTranslate}}</li>
                </ul>
              </div>
            </div>
            <div class="registration_nagivationPart" id="registration_nagivationPart4">
              <div class="registration_nagivationNo">
                <div class="registration_nagivationNumeric">4</div>
                <div class="registration_nagivationtick"><img src="assets\images\greentick.png" alt=""></div>
              </div>
              <div class="registration_nagivationName inactive">{{'progresslabel.reviewConfirm' | cxTranslate}}</div>
            </div>
          </div>
        </div>
        <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 registration_rightside no-padding-left">
          <div class=" registration_help">
            {{'bussinessDetails.Havingtrouble' | cxTranslate}} &nbsp;<a routerLink="/help-and-faq" class="showPopupclick"><span>{{'bussinessDetails.WeCanHelp' | cxTranslate}}</span><span class="global_blackarrow"></span></a>
          </div>
          <section class="registration_paying registrationFlow" id="registration_section3">
            <div class="registration_label padding-B10">{{'payinginfo.PayingInformation' | cxTranslate}}</div>
            <div class="registration_text1 padding-B10">{{'payinginfo.content1' | cxTranslate}}</div>
            <div class="registration_text2">{{'bussinessDetails.content2' | cxTranslate}}</div>
            <div class="registration_contact padding-B20">{{'payinginfo.PayingContact' | cxTranslate}}</div>
            <div class="padding-R15">
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
                <label class="registration_inputLabel " for="pay-firstname">{{'formLevel.firstName' | cxTranslate}}</label>
                <input class="registration_input form-control" formControlName="firstName" autocomplete="off" >
                @if (payerAddress.controls['firstName'].invalid && (isFormSubmitted_paying || payerAddress.controls['firstName'].touched || payerAddress.controls['firstName'].dirty)) {
                  <div class="text-danger">
                    <i class="fa-solid fa-circle-exclamation"></i>
                    @if (payerAddress.controls['firstName'].errors?.['required']) {
                      <label class="error help-block">{{'formLevel.firstNameError1' | cxTranslate}}</label>
                    }
                    @if (payerAddress.controls['firstName'].errors?.['pattern']) {
                      <label class="error help-block">{{'formLevel.firstNameError2' | cxTranslate}}</label>
                    }
                  </div>
                }
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding-right margin-B20 registration_parent form-group">
                <label class="registration_inputLabel " for="pay-lastname">{{'formLevel.lastName' | cxTranslate}}</label>
                <input class="registration_input form-control" id="pay-lastname" formControlName="lastName" autocomplete="off">
                @if (payerAddress.controls['lastName'].invalid && (isFormSubmitted_paying || payerAddress.controls['lastName'].touched || payerAddress.controls['lastName'].dirty)) {
                  <div class="text-danger">
                    <i class="fa-solid fa-circle-exclamation"></i>
                    @if (payerAddress.controls['lastName'].errors?.['required']) {
                      <label class="error help-block">{{'formLevel.lastNameError1' | cxTranslate}}</label>
                    }
                    @if (payerAddress.controls['lastName'].errors?.['pattern']) {
                      <label class="error help-block">{{'formLevel.lastNameError2' | cxTranslate}}</label>
                    }
                  </div>
                }
              </div>
              <div class="clearboth"></div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
              <label class="registration_inputLabel " for="pay-email">{{'formLevel.EmailAddress' | cxTranslate}}</label>
              <input class="registration_input form-control" id="email" formControlName="email" autocomplete="off">
              @if (payerAddress.controls['email'].invalid && (isFormSubmitted_paying || payerAddress.controls['email'].touched || payerAddress.controls['email'].dirty)) {
                <div class="text-danger">
                  <i class="fa-solid fa-circle-exclamation"></i>
                  @if (payerAddress.controls['email'].errors?.['required']) {
                    <label class="error help-block">{{'formLevel.EmailAddressError1' | cxTranslate}}</label>
                  }
                  @if (payerAddress.controls['email'].errors?.['pattern']) {
                    <label class="error help-block">{{'formLevel.EmailAddressError1' | cxTranslate}}</label>
                  }
                </div>
              }
            </div>
            <div class="clearboth"></div>
            <div class="padding-R15">
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
                <label class="registration_inputLabel" for="pay-phone">{{'formLevel.PhoneNumber' | cxTranslate}}</label>
                <p-inputMask class="registration_input form-control" autocomplete="off" autoClear="false"  mask="(999) 999-9999" pattern="^(\([2-9]([02-9]\d|1[02-9])\)|[2-9]([02-9]\d|1[02-9])) ?[2-9]\d{2}-?\d{4}$"  formControlName="phone"   />
                @if (payerAddress.controls['phone'].invalid && (isFormSubmitted_paying || payerAddress.controls['phone'].touched || payerAddress.controls['phone'].dirty)) {
                  <div class="text-danger">
                    <i class="fa-solid fa-circle-exclamation"></i>
                    @if (payerAddress.controls['phone'].errors?.['required']) {
                      <label class="error help-block">{{'formLevel.PhoneNumberError1' | cxTranslate}}</label>
                    }
                    @if (payerAddress.controls['phone'].errors?.['pattern']) {
                      <label class="error help-block">{{'formLevel.PhoneNumberError1' | cxTranslate}}</label>
                    }
                  </div>
                }
              </div>
              <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding-right margin-B20 registration_parent form-group">
                <label class="registration_inputLabel" for="pay-ext">{{'formLevel.phnext' | cxTranslate}}</label>
                <input class="registration_input form-control" id="pay-ext" formControlName="phoneExt" (keypress)="allowOnlyNumbers($event)" maxlength="4" autocomplete="off" >
              </div>
              <div class="clearboth"></div>
            </div>
            <div class="registration_contact padding-B20">{{'payinginfo.PayerAddress' | cxTranslate}}</div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
              <label class="registration_inputLabel " for="pay-orgname">{{'formLevel.OrganizationName' | cxTranslate}}</label>
              <input class="registration_input form-control"  autocomplete="off" formControlName="orgName" >
              @if (payerAddress.controls['orgName'].invalid && (isFormSubmitted_paying || payerAddress.controls['orgName'].touched || payerAddress.controls['orgName'].dirty)) {
                <div class="text-danger">
                  <i class="fa-solid fa-circle-exclamation"></i>
                  @if (payerAddress.controls['orgName'].errors?.['required']) {
                    <label class="error help-block">{{'formLevel.OrganizationNameError1' | cxTranslate}}</label>
                  }
                  @if (payerAddress.controls['orgName'].errors?.['pattern']) {
                    <label class="error help-block">{{'formLevel.OrganizationNameError2' | cxTranslate}}</label>
                  }
                </div>
              }
            </div>
            <div class="clearboth"></div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding-left margin-B30 registration_address form-group">
              <label class="registration_inputLabel " for="pay-lookup">{{'formLevel.AddressLookup' | cxTranslate}}</label>
              <input class="registration_input form-control" id="pay-lookup" name="paylookup"  placeholder="Start with post/zip code or street" >
              <span class="glyphicon glyphicon-search form-control-feedback"></span>
            </div>
            <div class="padding-R15">
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
                <label class="registration_inputLabel" for="billing-address1">{{'formLevel.AddressLine1' | cxTranslate}}</label>
                <input class="registration_input form-control" id="line1" name="addressLine1_paying" formControlName="line1"  autocomplete="off" >
                @if (payerAddress.controls['line1'].invalid && (isFormSubmitted_paying || payerAddress.controls['line1'].touched || payerAddress.controls['line1'].dirty)) {
                  <div class="text-danger" >
                    <i class="fa-solid fa-circle-exclamation"></i>
                    @if (payerAddress.controls['line1'].errors?.['required']) {
                      <label class="error help-block">{{'formLevel.AddressLine1Error' | cxTranslate}}</label>
                    }
                  </div>
                }
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding-right margin-B20 registration_parent form-group">
                <label class="registration_inputLabel" for="billing-address2">{{'formLevel.AddressLine2' | cxTranslate}}</label>
                <input class="registration_input form-control" id="line2" name="addressLine2_paying" formControlName="line2"  autocomplete="off" >
              </div>
              <div class="clearboth"></div>
            </div>
            <div class="padding-R15">
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
                <label class="registration_inputLabel" for="billing-city">{{'formLevel.City' | cxTranslate}}</label>
                <input class="registration_input form-control" id="city" name="city_paying"  autocomplete="off" formControlName="city">
                @if (payerAddress.controls['city'].invalid && (isFormSubmitted_paying || payerAddress.controls['city'].touched || payerAddress.controls['city'].dirty)) {
                  <div class="text-danger" >
                    <i class="fa-solid fa-circle-exclamation"></i>
                    @if (payerAddress.controls['city'].errors?.['required']) {
                      <label class="error help-block">{{'formLevel.CityError' | cxTranslate}}</label>
                    }
                  </div>
                }
              </div>
              <div class="col-lg-2 col-md-2 col-sm-6 col-xs-6 no-padding-right margin-B20 registration_mob form-group">
                <label class="registration_inputLabel " for="billing-state">{{'formLevel.State' | cxTranslate}}</label>
                <select class="registration_state form-control" id="state" formControlName="state" name="state_paying">
                  @for (item of stateList; track item) {
                    <option selected="selected" [value]="item.value">{{ item.label }}</option>
                  }
                </select>
                @if (payerAddress.controls['state'].invalid && (isFormSubmitted_paying || payerAddress.controls['state'].touched || payerAddress.controls['state'].dirty)) {
                  <div class="text-danger" >
                    <i class="fa-solid fa-circle-exclamation"></i>
                    @if (payerAddress.controls['state'].errors?.['required']) {
                      <label class="error help-block">{{'formLevel.StateError' | cxTranslate}}</label>
                    }
                  </div>
                }
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-xs-6 no-padding-right margin-B20 form-group">
                <label class="registration_inputLabel" for="billing-zipcode">{{'formLevel.ZipCode' | cxTranslate}}</label>
                <input class="registration_input form-control" id="postalCode" name="zipCode_paying" formControlName="postalCode" autocomplete="off" >
                @if (payerAddress.controls['postalCode'].invalid && (isFormSubmitted_paying || payerAddress.controls['postalCode'].touched || payerAddress.controls['postalCode'].dirty)) {
                  <div class="text-danger" >
                    <i class="fa-solid fa-circle-exclamation"></i>
                    @if (payerAddress.controls['postalCode'].errors?.['required']) {
                      <label class="error help-block">{{'formLevel.ZipCodeUSError1' | cxTranslate}}</label>
                    }
                    @if (payerAddress.controls['postalCode'].errors?.['pattern']) {
                      <label class="error help-block">{{'formLevel.ZipCodeUSError1' | cxTranslate}} </label>
                    }
                  </div>
                }
              </div>
              <div class="clearboth"></div>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding margin-T20 margin-B20 registration_button">
              <div class="registration_back active" (click)="showBillingSection()">
                <div class="global_blackarrow"></div>
                <span>{{'formLevel.Back' | cxTranslate}}</span>
                <div class="clearboth"></div>
              </div>
              <button type="button" (click)="onSubmit_paying()" class="registration_save active" id="registration_save">{{'formLevel.SaveandContinue' | cxTranslate}}</button>
              <div class="clearboth"></div>
            </div>
          </section>
        </div>
      </form>
    </div>
    <!------Paying Information Section Ends here------>
    <!------Shipping Information Section Starts here------>
    <div  [style.display]="isVisibleShipping ? 'block' : 'none'" >
      <form  class="registration col-xs-12 no-padding" [formGroup]="shippingForm">
        <div formArrayName="shippingList">
          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 registration_leftside no-padding-right">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 registration_nagivation no-padding">
              <div class="registration_nagivationPart" id="registration_nagivationPart1">
                <div class="registration_nagivationNo">
                  <div class="registration_nagivationtick registration_Nagivationtick_Part1"><img src="assets\images\greentick.png" alt=""></div>
                </div>
                <div class="registration_nagivationName">{{'progresslabel.userProfile' | cxTranslate}}</div>
              </div>
              <div class="registration_nagivationPart" id="registration_nagivationPart2">
                <div class="registration_nagivationNo">
                  <div class="registration_nagivationNumeric registration_NagivationNumeric_Part2">2</div>
                  <div class="registration_nagivationtick registration_Nagivationtick_Part2"><img src="assets\images\greentick.png" alt=""></div>
                </div>
                <div class="registration_nagivationName">{{'progresslabel.businessDetails' | cxTranslate}}</div>
              </div>
              <div class="registration_nagivationPart" id="registration_nagivationPart3">
                <div class="registration_nagivationNo">
                  <div class="registration_nagivationNumeric">3</div>
                  <div class="registration_nagivationtick"><img src="assets\images\greentick.png" alt=""></div>
                </div>
                <div class="registration_nagivationName active">{{'progresslabel.contactAddress' | cxTranslate}}<ul>
                  <li class="billing_Info_Li">{{'progresslabel.billinginformation' | cxTranslate}}</li>
                  <li class="payment_Info_Li">{{'progresslabel.payingInformation' | cxTranslate}}</li>
                  <li class="active shiiping_Location_Li">{{'progresslabel.shippingLocation' | cxTranslate}}</li>
                </ul>
              </div>
            </div>
            <div class="registration_nagivationPart" id="registration_nagivationPart4">
              <div class="registration_nagivationNo">
                <div class="registration_nagivationNumeric">4</div>
                <div class="registration_nagivationtick"><img src="assets\images\greentick.png" alt=""></div>
              </div>
              <div class="registration_nagivationName inactive">{{'progresslabel.reviewConfirm' | cxTranslate}}</div>
            </div>
          </div>
        </div>
        <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 registration_rightside no-padding-left">
          <div class=" registration_help">
            {{'bussinessDetails.Havingtrouble' | cxTranslate}} &nbsp;<a routerLink="/help-and-faq" class="showPopupclick"><span>{{'bussinessDetails.WeCanHelp' | cxTranslate}}</span><span class="global_blackarrow"></span></a>
          </div>
          <section class="registration_shipping registrationFlow" [ngClass]="{'show-shipping': showShippingFormOnly}"  id="registration_section4" >
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding-left registration_label padding-B10">
              <div class="col-lg-5 col-md-5 no-padding">{{"Shippinglocations.ShippingLocations" | cxTranslate}}</div>
              <div class="col-lg-7 col-md-7 uploadcont no-padding">
                @if (templateUrl) {
                  <div class="registration_download"><a [href]="templateUrl"  class="showPopupclick">{{"Shippinglocations.DownloadTemplate" | cxTranslate}}&nbsp;<span class="glyphicon glyphicon-download-alt"></span></a></div>
                }
                <div class="registration_upload" id="registration_upload" (click)="open_shipping_popup()">{{"Shippinglocations.UploadShippingLocations" | cxTranslate}}</div>
              </div>
            </div>
            <div class="registration_text1 padding-B10">{{"Shippinglocations.content1" | cxTranslate}}</div>
            <div class="registration_text1 padding-B10">{{"Shippinglocations.content2" | cxTranslate}}</div>
            <div class="registration_text2">{{"Shippinglocations.instruction1" | cxTranslate}}</div>
            <!---Add Shipping Locations starts----->
            <div class="print_shipping" >
            </div>
            <!---Add Shipping Locations ends----->
            @for (shipping of shippingList.controls; track shipping; let i = $index) {
              <div [formGroupName]="i">
                @if (!shipping.get('isEditing')?.value && shipping.get('submitted')?.value) {
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 registration_locations" [style.display]="shipping.get('submitted')?.value ? 'block' : 'none'" >
                    <div class="registration_locationparent">
                      <div class="registration_locationLine1">
                        <div class="registration_locationName">{{"Shippinglocations.Location" | cxTranslate}} <span class="locationno">{{ i + 1 }}</span>
                      </div>
                      <div class="registration_locationOrg">{{ shipping.get('orgName')?.value }}
                      </div>
                      <div class="clearboth"></div>
                    </div>
                    <div class="registration_edit ship_del" (click)="removeShipping(i)">{{"Shippinglocations.Remove" | cxTranslate}} <i class="fa fa-trash" aria-hidden="true"></i>
                  </div>
                  <div class="registration_edit only_edit_ship" (click)="toggleShipping(i)">{{"Shippinglocations.Edit" | cxTranslate}} <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                </div>
                <div class="clearboth"></div>
              </div>
              <div class="registration_locationLine2">
                <div class="registration_locationcontact">
                  <div class="registration_locationcontactline1">Contact Info</div>
                  <div class="registration_locationcontactname">
                    <span>{{ shipping.get('firstName')?.value }}</span>&nbsp; <span>{{ shipping.get('lastName')?.value }}</span>
                  </div>
                  <div class="registration_locationcontactemail">
                    <span>{{ shipping.get('email')?.value }}</span>
                  </div>
                  <div class="registration_locationcontactphn">
                    <span>{{ shipping.get('phone')?.value }}</span> ext. <span>{{ shipping.get('phoneExt')?.value }}</span>
                  </div>
                </div>
                <div class="registration_locationaddress">
                  <div class="registration_locationcontactline1">{{"Shippinglocations.Address" | cxTranslate}}</div>
                  <div class="registration_locationaddress1">
                    <span>{{ shipping.get('line1')?.value }}</span>
                  </div>
                  <div class="registration_locationaddress2">
                    <span>
                      {{ shipping.get('line2')?.value }}
                    </span>
                  </div>
                  <div class="registration_locationaddress4">
                    <span>{{ shipping.get('city')?.value }}
                    </span>,<span>{{ shipping.get('state')?.value }}
                  </span>
                  <span>{{ shipping.get('postalCode')?.value }}
                  </span>
                </div>
              </div>
              <div class="registration_locationLic">
                <div class="registration_locationcontactline1">{{"Shippinglocations.License" | cxTranslate}}</div>
                <div class="registration_locationlic1">
                  <span>{{ shipping.get('licenseDetailsForm.licenseName')?.value }}
                  </span> - <span>{{ shipping.get('licenseDetailsForm.licenseNum')?.value }}
                </span>
                <span>
                </span>
              </div>
              <div class="registration_locationlic3">
                <span>{{ shipping.get('licenseDetailsForm.licAddressLine1')?.value }}
                </span>
              </div>
              <div class="registration_locationlic4">
                <span>
                  {{ shipping.get('licenseDetailsForm.licAddressLine2')?.value }}
                </span>
              </div>
              <div class="registration_locationlic5">
                <span>{{ shipping.get('licenseDetailsForm.licenseCity')?.value }}
                </span>,<span>{{ shipping.get('licenseDetailsForm.licenseState')?.value }}
              </span>
              <span>{{ shipping.get('licenseDetailsForm.licensePostalCode')?.value }}
              </span>
            </div>
          </div>
          <div class="clearboth"></div>
        </div>
      </div>
    }
    <div class="clearboth"></div>
    @if (shipping.get('isEditing')?.value || !shipping.get('submitted')?.value) {
      <div class="shipping-block" [ngClass]="{'registration_locations': shipping.get('isEditing')?.value}">
        @if (showEditbtn) {
          <div class="row"><div class="col-md-12"><div class="registration_locationName no-right-border">Location <span class="locationno">{{i + 1}}</span></div></div></div>
        }
        <div class="registration_contact padding-B20">{{"Shippinglocations.ShippingLocationContact" | cxTranslate}} &nbsp;&nbsp;<span [attr.tooltip]="tooltipText3" tooltip-position="buttom" ><i class="fa fa-question-circle-o" ></i></span>@if (i > 0) {
        <div class="registration_edit add_ship_del" (click)="removeShipping(i)">Remove <i class="fa fa-trash" aria-hidden="true"></i></div>
      }</div>
      <div class="padding-R15">
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
          <label class="registration_inputLabel" for="shipping-firstname">{{"formLevel.firstName" | cxTranslate}}</label>
          <input class="registration_input form-control" formControlName="firstName" autocomplete="off">
          @if (shipping.get('firstName')?.invalid && (isFormSubmitted_shipping || shipping.get('firstName')?.touched || shipping.get('firstName')?.dirty)) {
            <div class="text-danger">
              <i class="fa-solid fa-circle-exclamation"></i>
              @if (shipping.get('firstName')?.errors?.['required']) {
                <div class="error help-block">{{"formLevel.firstNameError1" | cxTranslate}}</div>
              }
              @if (shipping.get('firstName')?.errors?.['pattern']) {
                <div class="error help-block">{{"formLevel.firstNameError2" | cxTranslate}}</div>
              }
            </div>
          }
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding-right margin-B20 registration_parent form-group">
          <label class="registration_inputLabel" for="shipping-lastname">{{"formLevel.lastName" | cxTranslate}}</label>
          <input class="registration_input form-control" formControlName="lastName" autocomplete="off">
          @if (shipping.get('lastName')?.invalid && (isFormSubmitted_shipping || shipping.get('lastName')?.touched || shipping.get('lastName')?.dirty)) {
            <div class="text-danger">
              <i class="fa-solid fa-circle-exclamation"></i>
              @if (shipping.get('lastName')?.errors?.['required']) {
                <div class="error help-block">{{"formLevel.lastNameError1" | cxTranslate}}</div>
              }
              @if (shipping.get('lastName')?.errors?.['pattern']) {
                <div class="error help-block">{{"formLevel.lastNameError2" | cxTranslate}}</div>
              }
            </div>
          }
        </div>
        <div class="clearboth"></div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
        <label class="registration_inputLabel" for="shipping-email">{{"formLevel.EmailAddress" | cxTranslate}}</label>
        <input class="registration_input form-control" formControlName="email" autocomplete="off">
        @if (shipping.get('email')?.invalid && (isFormSubmitted_shipping || shipping.get('email')?.touched || shipping.get('email')?.dirty)) {
          <div class="text-danger">
            <i class="fa-solid fa-circle-exclamation"></i>
            @if (shipping.get('email')?.errors?.['required']) {
              <div class="error help-block">{{"formLevel.EmailAddressError1" | cxTranslate}}</div>
            }
            @if (shipping.get('email')?.errors?.['pattern']) {
              <div class="error help-block">{{"formLevel.EmailAddressError1" | cxTranslate}}</div>
            }
          </div>
        }
      </div>
      <div class="clearboth"></div>
      <div class="padding-R15">
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
          <label class="registration_inputLabel" for="shipping-phno">{{"formLevel.PhoneNumber" | cxTranslate}}</label>
          <p-inputMask class="registration_input form-control" autocomplete="off" autoClear="false"  mask="(999) 999-9999" pattern="^(\([2-9]([02-9]\d|1[02-9])\)|[2-9]([02-9]\d|1[02-9])) ?[2-9]\d{2}-?\d{4}$"  formControlName="phone"   />
          @if (shipping.get('phone')?.invalid && (isFormSubmitted_shipping || shipping.get('phone')?.touched || shipping.get('phone')?.dirty)) {
            <div class="text-danger">
              <i class="fa-solid fa-circle-exclamation"></i>
              @if (shipping.get('phone')?.errors?.['required']) {
                <div class="error help-block">{{"formLevel.PhoneNumberError1" | cxTranslate}}</div>
              }
              @if (shipping.get('phone')?.errors?.['pattern']) {
                <div class="error help-block">{{"formLevel.PhoneNumberError1" | cxTranslate}}</div>
              }
            </div>
          }
        </div>
        <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding-right margin-B20 registration_parent form-group">
          <label class="registration_inputLabel" for="shipping-extension">{{"formLevel.phnext" | cxTranslate}}</label>
          <input class="registration_input form-control" formControlName="phoneExt" (keypress)="allowOnlyNumbers($event)" maxlength="4" autocomplete="no">
        </div>
        <div class="clearboth"></div>
      </div>
      <div class="registration_contact padding-B20">{{"Shippinglocations.ShippingAddress" | cxTranslate}}</div>
      <div class="padding-R15">
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
          <label class="registration_inputLabel" for="shipping-orgname">{{"formLevel.OrganizationName" | cxTranslate}}</label>
          <input class="registration_input form-control" formControlName="orgName" autocomplete="off">
          @if (shipping.get('orgName')?.invalid && (isFormSubmitted_shipping || shipping.get('orgName')?.touched || shipping.get('orgName')?.dirty)) {
            <div class="text-danger">
              <i class="fa-solid fa-circle-exclamation"></i>
              @if (shipping.get('orgName')?.errors?.['required']) {
                <div class="error help-block">{{"formLevel.OrganizationNameError1" | cxTranslate}}</div>
              }
              @if (shipping.get('orgName')?.errors?.['pattern']) {
                <div class="error help-block">{{"formLevel.OrganizationNameError2" | cxTranslate}}</div>
              }
            </div>
          }
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 padding-left margin-B20 registration_parent form-group">
          <label class="registration_inputLabel shipping-gln" for="shipping-gln">{{'bussinessDetails.GLN' | cxTranslate}} <i class="fa-regular fa-circle-question locations_qm locations_tooltip"><span class="locations_tooltiptext" [innerHTML]="'bussinessDetails.GLNTooltips' | cxTranslate"></span></i></label>
          <p-inputMask class="registration_input form-control" autoClear="false"  mask="9999999.99999.9" pattern="\d\d\d\d\d\d\d\.\d\d\d\d\d\.\d" id="addressNumber" formControlName="globalLocationNumber"   />
          @if (shipping.get('globalLocationNumber')?.invalid && (isFormSubmitted_shipping || shipping.get('globalLocationNumber')?.touched || shipping.get('globalLocationNumber')?.dirty)) {
            <div class="text-danger">
              <i class="fa-solid fa-circle-exclamation gln_Circle_Exclamation"></i>
              @if (shipping.get('globalLocationNumber')?.errors?.['pattern']) {
                <div class="error help-block">{{'bussinessDetails.GLNError1' | cxTranslate}}</div>
              }
            </div>
          }
        </div>
      </div>
      <div class="clearboth"></div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding-left margin-B30 registration_address form-group" >
        <label class="registration_inputLabel" for="shipping-lookup1">{{"formLevel.AddressLookup" | cxTranslate}}</label>
        <input class="registration_input form-control addresslook" formControlName="addressId"  [id]="'shipping_lookup' + i"  [name]="'shipping_lookup' + i"  placeholder="Start with post/zip code or street">
        <span class="glyphicon glyphicon-search form-control-feedback"></span>
      </div>
      <div class="padding-R15">
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
          <label class="registration_inputLabel" for="shipping-address1">{{"formLevel.AddressLine1" | cxTranslate}}</label>
          <input class="registration_input form-control" formControlName="line1" id="line1{{i}}" name="line1{{i}}" autocomplete="off">
          @if (shipping.get('line1')?.invalid && (isFormSubmitted_shipping || shipping.get('line1')?.touched || shipping.get('line1')?.dirty)) {
            <div class="text-danger">
              <i class="fa-solid fa-circle-exclamation"></i>
              @if (shipping.get('line1')?.errors?.['required']) {
                <div class="error help-block">{{"formLevel.AddressLine1Error" | cxTranslate}}</div>
              }
            </div>
          }
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding-right margin-B20 registration_parent form-group">
          <label class="registration_inputLabel" for="shipping-address2">{{"formLevel.AddressLine2" | cxTranslate}}</label>
          <input class="registration_input form-control" formControlName="line2" name="line2{{i}}" id="line2{{i}}" autocomplete="off">
        </div>
        <div class="clearboth"></div>
      </div>
      <div class="padding-R15">
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
          <label class="registration_inputLabel" for="shipping-city1">{{"formLevel.City" | cxTranslate}}</label>
          <input class="registration_input form-control" formControlName="city" name="city{{i}}" id="city{{i}}" autocomplete="off">
          @if (shipping.get('city')?.invalid && (isFormSubmitted_shipping || shipping.get('city')?.touched || shipping.get('city')?.dirty)) {
            <div class="text-danger">
              <i class="fa-solid fa-circle-exclamation"></i>
              @if (shipping.get('city')?.errors?.['required']) {
                <div class="error help-block">{{"formLevel.CityError" | cxTranslate}}</div>
              }
            </div>
          }
        </div>
        <div class="col-lg-2 col-md-2 col-sm-6 col-xs-6 no-padding-right margin-B20 registration_mob form-group">
          <label class="registration_inputLabel" for="shipping-state1">{{"formLevel.State" | cxTranslate}}</label>
          <select class="registration_state form-control"  formControlName="state" name="state{{i}}" id="state{{i}}">
            @for (item of stateList; track item) {
              <option selected="selected" [value]="item.value">{{ item.label }}</option>
            }
          </select>
          @if (shipping.get('state')?.invalid && (isFormSubmitted_shipping || shipping.get('state')?.touched || shipping.get('state')?.dirty)) {
            <div class="text-danger">
              <i class="fa-solid fa-circle-exclamation"></i>
              @if (shipping.get('state')?.errors?.['required']) {
                <div class="error help-block">{{"formLevel.StateError" | cxTranslate}}</div>
              }
            </div>
          }
        </div>
        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-6 no-padding-right margin-B20 form-group">
          <label class="registration_inputLabel" for="shipping-zip1">{{"formLevel.ZipCode" | cxTranslate}}</label>
          <input class="registration_input form-control" formControlName="postalCode" name="postalCode{{i}}" id="postalCode{{i}}" autocomplete="off">
          @if (shipping.get('postalCode')?.invalid && (isFormSubmitted_shipping || shipping.get('postalCode')?.touched || shipping.get('postalCode')?.dirty)) {
            <div class="text-danger">
              <i class="fa-solid fa-circle-exclamation"></i>
              @if (shipping.get('postalCode')?.errors?.['required']) {
                <div class="error help-block">{{"formLevel.ZipCodeUSError1" | cxTranslate}}</div>
              }
              @if (shipping.get('postalCode')?.errors?.['pattern']) {
                <div class="error help-block">{{"formLevel.ZipCodeUSError1" | cxTranslate}}</div>
              }
            </div>
          }
        </div>
        <div class="clearboth"></div>
      </div>
      <div formGroupName="licenseDetailsForm">
        <div class="registration_contact padding-B20">{{"Shippinglocations.License" | cxTranslate}}</div>
        <div class="padding-R15">
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
            <label class="registration_inputLabel" for="shipping-licensename">{{"Shippinglocations.NameonLicense" | cxTranslate}}</label>
            <input class="registration_input form-control" formControlName="licenseName" name="shipping_licenseName" autocomplete="off">
            @if (shipping.get('licenseDetailsForm.licenseName')?.invalid && (isFormSubmitted_shipping || shipping.get('licenseDetailsForm.licenseName')?.touched || shipping.get('licenseDetailsForm.licenseName')?.dirty)) {
              <div class="text-danger">
                <i class="fa-solid fa-circle-exclamation"></i>
                @if (shipping.get('licenseDetailsForm.licenseName')?.errors?.['required']) {
                  <div class="error help-block">{{"Shippinglocations.NameonLicenseError1" | cxTranslate}}</div>
                }
              </div>
            }
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding-right margin-B20 registration_parent form-group">
            <label class="registration_inputLabel" for="shipping-licenseno">{{"Shippinglocations.StateLicenseNumber" | cxTranslate}}</label>
            <input class="registration_input form-control" maxlength="35" formControlName="licenseNum" name="shipping_licenseNum" autocomplete="off" >
            @if (shipping.get('licenseDetailsForm.licenseNum')?.invalid && (isFormSubmitted_shipping || shipping.get('licenseDetailsForm.licenseNum')?.touched || shipping.get('licenseDetailsForm.licenseNum')?.dirty)) {
              <div class="text-danger">
                <i class="fa-solid fa-circle-exclamation"></i>
                @if (shipping.get('licenseDetailsForm.licenseNum')?.errors?.['required']) {
                  <div class="error help-block">{{"Shippinglocations.licensenumerror1" | cxTranslate}}</div>
                }
              </div>
            }
          </div>
          <div class="clearboth"></div>
        </div>
        <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 no-padding-left margin-B20 shipping_check registration_parent form-group">
          <label class="checkbox-button">
            <input type="checkbox" class="registration_checkbox form-group checkboxship_0" formControlName="checkboxControl"  (change)="copyValues(i)">
            <span class="checkbox-button__control"></span>
          </label>
          <label class="registration_checkboxLabel" for="shipping-checkbox">{{"Shippinglocations.Sameaddress" | cxTranslate}}</label>
          <div class="clearboth"></div>
        </div>
        <div class="clearboth"></div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding-left margin-B30 registration_address form-group">
          <label class="registration_inputLabel" for="shipping-lookup2">{{"formLevel.AddressLookup" | cxTranslate}}</label>
          <input class="registration_input form-group" id="shipping-lookup2" name="shipping-lookup2"  placeholder="Start with post/zip code or street">
          <span class="glyphicon glyphicon-search form-control-feedback"></span>
        </div>
        <div class="padding-R15">
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
            <label class="registration_inputLabel" for="shipping-address3">{{"formLevel.AddressLine1" | cxTranslate}}</label>
            <input class="registration_input form-control" formControlName="licAddressLine1" name="licAddressLine1" autocomplete="off">
            @if (shipping.get('licenseDetailsForm.licAddressLine1')?.invalid && (isFormSubmitted_shipping || shipping.get('licenseDetailsForm.licAddressLine1')?.touched || shipping.get('licenseDetailsForm.licAddressLine1')?.dirty)) {
              <div class="text-danger">
                <i class="fa-solid fa-circle-exclamation"></i>
                @if (shipping.get('licenseDetailsForm.licAddressLine1')?.errors?.['required']) {
                  <div class="error help-block">{{"formLevel.AddressLine1Error" | cxTranslate}}</div>
                }
              </div>
            }
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding-right margin-B20 registration_parent form-group">
            <label class="registration_inputLabel" for="shipping-address4">{{"formLevel.AddressLine2" | cxTranslate}}</label>
            <input class="registration_input form-control" formControlName="licAddressLine2" name="licAddressLine2" autocomplete="off">
          </div>
          <div class="clearboth"></div>
        </div>
        <div class="padding-R15">
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
            <label class="registration_inputLabel" for="shipping-city2">{{"formLevel.City" | cxTranslate}}</label>
            <input class="registration_input form-control" formControlName="licenseCity" name="licenseCity" autocomplete="off">
            @if (shipping.get('licenseDetailsForm.licenseCity')?.invalid && (isFormSubmitted_shipping || shipping.get('licenseDetailsForm.licenseCity')?.touched || shipping.get('licenseDetailsForm.licenseCity')?.dirty)) {
              <div class="text-danger">
                <i class="fa-solid fa-circle-exclamation"></i>
                @if (shipping.get('licenseDetailsForm.licenseCity')?.errors?.['required']) {
                  <div class="error help-block">{{"formLevel.CityError" | cxTranslate}}</div>
                }
              </div>
            }
          </div>
          <div class="col-lg-2 col-md-2 col-sm-6 col-xs-6 no-padding-right margin-B20 registration_mob form-group">
            <label class="registration_inputLabel" for="shipping-state2">{{"formLevel.State" | cxTranslate}}</label>
            <select class="registration_state form-control"  formControlName="licenseState" name="licenseState">
              @for (item of stateList; track item) {
                <option selected="selected" [value]="item.value">{{ item.label }}</option>
              }
            </select>
            @if (shipping.get('licenseDetailsForm.licenseState')?.invalid && (isFormSubmitted_shipping || shipping.get('licenseDetailsForm.licenseState')?.touched || shipping.get('licenseDetailsForm.licenseState')?.dirty)) {
              <div class="text-danger">
                <i class="fa-solid fa-circle-exclamation"></i>
                @if (shipping.get('licenseDetailsForm.licenseState')?.errors?.['required']) {
                  <div class="error help-block">{{"formLevel.StateError" | cxTranslate}}</div>
                }
              </div>
            }
          </div>
          <div class="col-lg-4 col-md-4 col-sm-6 col-xs-6 no-padding-right margin-B20 form-group">
            <label class="registration_inputLabel" for="shipping-zip2">{{"formLevel.ZipCode" | cxTranslate}}</label>
            <input class="registration_input form-control" formControlName="licensePostalCode" name="licensePostalCode" autocomplete="off">
            @if (shipping.get('licenseDetailsForm.licensePostalCode')?.invalid && (isFormSubmitted_shipping || shipping.get('licenseDetailsForm.licensePostalCode')?.touched || shipping.get('licenseDetailsForm.licensePostalCode')?.dirty)) {
              <div class="text-danger">
                <i class="fa-solid fa-circle-exclamation"></i>
                @if (shipping.get('licenseDetailsForm.licensePostalCode')?.errors?.['required']) {
                  <div class="error help-block">{{"formLevel.ZipCodeUSError1" | cxTranslate}}</div>
                }
                @if (shipping.get('licenseDetailsForm.licensePostalCode')?.errors?.['pattern']) {
                  <div class="error help-block">{{"formLevel.ZipCodeUSError1" | cxTranslate}}</div>
                }
              </div>
            }
          </div>
        </div>
        @if (shipping.get('isEditing')?.value) {
          <button type="button" class="shipping_edit_save" (click)="checkLicense2(i)">{{"formLevel.save" | cxTranslate}}</button>
        }
      </div>
      <div class="clearboth"></div>
      @if (!shipping.get('isEditing')?.value) {
        <div class="registration_addbutton padding-B20 registration_addbutton_disable" [style.display]="!isVisible ? 'none' : 'block'"   (click)="onSubmit_shipping(i)" [ngClass]="{'registration_addbutton_disable': !formValid}" >{{"Shippinglocations.AddAnotherLocation" | cxTranslate}}&nbsp;<span class="glyphicon glyphicon-remove-circle"></span></div>
      }
    </div>
  }
</div>
}
<div  class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding margin-T20 margin-B20 registration_button">
  @for (shipping of shippingList.controls; track shipping; let i = $index) {
    <div [formGroupName]="i">
      @if (i === shippingList.controls.length - 1) {
        <div >
          @if (toggleButtonVisibility(i) && !isAnyFormEditing) {
            <div class="padding-B20 only_show_field"    (click)="addShipping()">{{"Shippinglocations.AddAnotherLocation" | cxTranslate}}&nbsp;<span class="glyphicon glyphicon-remove-circle"></span></div>
          }
          <div class="registration_back active" (click)="showPayingSection()" >
            <div class="global_blackarrow"></div>
            <span>{{"formLevel.Back" | cxTranslate}}</span>
            <div class="clearboth"></div>
          </div>
          @if (!isVisible) {
            <button type="button" (click)="save_next_shipping(i)"   class="registration_save active" id="registration_save" >{{"formLevel.SaveandContinue" | cxTranslate}}
            </button>
          }
          @if (isVisible) {
            <button type="button" (click)="onSubmit_shipping_license(i)"  class="registration_save active" id="registration_save" >{{"formLevel.SaveandContinue" | cxTranslate}}</button>
          }
        </div>
      }
    </div>
  }
  <div class="clearboth"></div>
</div>
</section>
<!-----After Shipping Template Upload section starts----->
@if (showAfterShippingUpload) {
  <section class="registration_uploadConfirm registrationFlow" id="registration_uploadConfirm">
    <div class="registration_label padding-B10">{{"Shippinglocations.ShippingLocations" | cxTranslate}}</div>
    <div class="registration_shippingUploadtext2 margin-B10" [innerHTML]="'Shippinglocations.content3' | cxTranslate">
    </div>
    <div class=" margin-B10">
      <div class="registration_shippingUploadtext2 uploadformat"><span class="accepted_File_Formats_Txt">{{"Shippinglocations.AcceptedFileFormats" | cxTranslate}}</span> .xls, .xlsx</div>
      <div class="registration_popcont">
        @if (templateUrl) {
          <div class="registration_download"><a [href]="templateUrl" class="showPopupclick">{{"Shippinglocations.DownloadTemplate" | cxTranslate}} &nbsp;<span class="glyphicon glyphicon-download-alt"></span></a></div>
        }
        <input type="file"  id="upload" #fileInput (change)="onFileSelected($event)" accept=".xls,.xlsx" hidden/>
        <label for="upload" [ngClass]="{'inactive': file, 'active': !file}">{{"Shippinglocations.UploadLocationDocuments" | cxTranslate}}</label>
      </div>
      <div class="clearboth"></div>
    </div>
    <div>
      @if (errorMessage) {
        <p class="registration_uploadFile registration_UploadFile_ErrorMsg">{{ errorMessage }}</p>
      }
      @if (fileName) {
        <div class="registration_uploadFile registration_UploadFile_Name">{{ fileName }} <button (click)="removeUploadFile()" class="registration_uploadclose">X</button></div>
      }
    </div>
    <div class="registration_shippingUploadtext2 margin-B10">Please ensure that these are the correct documents before continuing, complete with <span>main contact</span> (name, email, and phone number) for each location, as well as the <span>full address</span> and <span>license information</span> If your upload is missing important information, we will contact you within 5 business days. This may affect location verification, which could delay any orders or shipments. You can also upload more than 1 document, or choose to <span class="registration_manualLocation" (click)="returnToShipping()">manually upload locations</span> instead.</div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding margin-T20 margin-B20 registration_button">
      <div class="registration_back active" (click)="returnToShipping()">
        <div class="global_blackarrow"></div>
        <span>{{"formLevel.Back" | cxTranslate}}</span>
        <div class="clearboth"></div>
      </div>
      <button class="registration_save active" type="submit" id="registration_save" (click)="uploadFile()">{{"formLevel.SaveandContinue" | cxTranslate}}</button>
      <div class="clearboth"></div>
    </div>
  </section>
}
<!-------After Shipping Template Upload section ends--------->
</div>
</div>
</form>
</div>
<!-----------Shipping Upload Popup Section Starts------->
@if (showShippingUpload) {
  <div class="registration_shippingUploadpop modal">
    <div class="registration_shippingUploadContent">
      <div class="registration_shippingUploadheader">
        <div class="registration_shippingUploadtext1 margin-B10">{{"Shippinglocations.prefertouploadtxt" | cxTranslate}}</div>
        <div class="registration_shippingUploadclose margin-B10" (click)="close_shipping_popup()">X</div>
        <div class="clearboth"></div>
      </div>
      <div class="registration_shippingUploadtext2 margin-B10" [innerHTML]="'Shippinglocations.uploadlocationmessage' | cxTranslate">
      </div>
      <div class=" margin-B10">
        <div class="registration_shippingUploadtext2 uploadformat"><span class="accepted_File_Formats_Txt">{{"Shippinglocations.AcceptedFileFormats" | cxTranslate}}</span> .xls, .xlsx</div>
        <div class="registration_popcont">
          @if (templateUrl) {
            <div class="registration_download"><a [href]="templateUrl" class="showPopupclick">{{"Shippinglocations.DownloadTemplate" | cxTranslate}} &nbsp;<span class="glyphicon glyphicon-download-alt"></span></a></div>
          }
          <input type="file"  id="upload" #fileInput (change)="onFileSelected($event)" accept=".xls,.xlsx" hidden/>
          <label for="upload" [ngClass]="{'inactive': file, 'active': !file}">{{"Shippinglocations.UploadLocationDocuments" | cxTranslate}}</label>
          <div class="clearboth"></div>
        </div>
        <div class="clearboth"></div>
      </div>
      <div>
      </div>
      <div>
        @if (errorMessage) {
          <p class="registration_uploadFile registration_UploadFile_ErrorMsg">{{ errorMessage }}</p>
        }
        @if (fileName) {
          <div class="registration_uploadFile registration_UploadFile_Name">{{ fileName }} <button (click)="removeUploadFile()" class="registration_uploadclose">X</button></div>
        }
      </div>
      <button class="registration_shippingSave" (click)="close_shipping_popup()" [ngClass]="{'active': file, 'inactive': !file}" type="button">{{"formLevel.save" | cxTranslate}}</button>
    </div>
  </div>
}
<!-----------Shipping Upload Popup Section Ends------->
<!-----------License Validation Sections here--------->
@if (licenseErrorPopup) {
  <div class="registration_medpropop3 modal">
    @for (shipping of shippingList.controls; track shipping; let i = $index) {
      <div class="registration_medproContent">
        <div class="registration_helpheader">
          <div class="registration_medheader">{{"Shippinglocations.medpropopup.title" | cxTranslate}}</div>
          <div class="registration_medproclose" (click)="closeModal()">X</div>
          <div class="clearboth"></div>
        </div>
        <div class="registration_medsubheader">{{"Shippinglocations.medpropopup.message" | cxTranslate}}</div>
        <div class="registration_medpop">
          <button class="registration_medprobutton medprom1 registration_medpromodify" (click)="closeModal()">{{"Shippinglocations.medpropopup.modifylicenseinfo" | cxTranslate}}</button>
          <button class="registration_medprobutton medprom2 medproaddlocation2" (click)="onSave_shipping(i)" >{{"Shippinglocations.medpropopup.continuewithoutvalidating" | cxTranslate}}</button>
        </div>
      </div>
    }
  </div>
}
<!-----------License Validation Section Ends here----->
@if (licenseErrorPopup1) {
  <div class="registration_medpropop3 modal">
    @for (shipping of shippingList.controls; track shipping; let i = $index) {
      <div class="registration_medproContent">
        <div class="registration_helpheader">
          <div class="registration_medheader">{{"Shippinglocations.medpropopup.title" | cxTranslate}}</div>
          <div class="registration_medproclose" (click)="closeModal1()">X</div>
          <div class="clearboth"></div>
        </div>
        <div class="registration_medsubheader">{{"Shippinglocations.medpropopup.message" | cxTranslate}}</div>
        <div class="registration_medpop">
          <button class="registration_medprobutton medprom1 registration_medpromodify" (click)="closeModal1()">{{"Shippinglocations.medpropopup.modifylicenseinfo" | cxTranslate}}</button>
          <button class="registration_medprobutton medprom2 medproaddlocation2" (click)="save_license_shipping(i)" >{{"Shippinglocations.medpropopup.continuewithoutvalidating" | cxTranslate}}</button>
        </div>
      </div>
    }
  </div>
}
@if (licenseErrorPopup2) {
  <div class="registration_medpropop3 modal">
    @for (shipping of shippingList.controls; track shipping; let i = $index) {
      <div class="registration_medproContent">
        <div class="registration_helpheader">
          <div class="registration_medheader">{{"Shippinglocations.medpropopup.title" | cxTranslate}}</div>
          <div class="registration_medproclose" (click)="closeModal2()">X</div>
          <div class="clearboth"></div>
        </div>
        <div class="registration_medsubheader">{{"Shippinglocations.medpropopup.message" | cxTranslate}}</div>
        <div class="registration_medpop">
          <button class="registration_medprobutton medprom1 registration_medpromodify" (click)="closeModal2()">{{"Shippinglocations.medpropopup.modifylicenseinfo" | cxTranslate}}</button>
          <button class="registration_medprobutton medprom2 medproaddlocation2" (click)="modifyForm(i, shipping.value)" >{{"Shippinglocations.medpropopup.continuewithoutvalidating" | cxTranslate}}</button>
        </div>
      </div>
    }
  </div>
}
<!------Shipping Information Section Ends here------>
<!-------Exit Popup Confirmation Popup---------->
@if (registrationExitpopup) {
  <div class="registration_medpropop3 modal">
    @for (shipping of shippingList.controls; track shipping; let i = $index) {
      <div class="registration_medproContent">
        <div class="registration_helpheader">
          <div class="registration_medheader">{{"Shippinglocations.exitpopup.title" | cxTranslate}}</div>
          <div class="registration_medproclose" (click)="closeExitpopup()">X</div>
          <div class="clearboth"></div>
        </div>
        <div class="registration_medsubheader">{{"Shippinglocations.exitpopup.message" | cxTranslate}}</div>
        <div class="registration_popcont">
          <button class="registration_helpContinue"  (click)="closeExitpopup()">{{"Shippinglocations.exitpopup.continue" | cxTranslate}}</button>
          <button class="registration_helpLeave" (click)="redirectTojointaccount()">{{"Shippinglocations.exitpopup.leavenlose" | cxTranslate}}</button>
        </div>
      </div>
    }
  </div>
}
<!------Review Page section Starts here------>
<div class="registration col-xs-12 no-padding" [style.display]="isVisibleReview ? 'block' : 'none'">
  <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 registration_leftside no-padding-right">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 registration_nagivation no-padding">
      <div class="registration_nagivationPart" id="registration_nagivationPart1">
        <div class="registration_nagivationNo">
          <div class="registration_nagivationtick registration_Nagivationtick_Part1"><img src="assets\images\greentick.png" alt=""></div>
        </div>
        <div class="registration_nagivationName">{{'progresslabel.userProfile' | cxTranslate}}</div>
      </div>
      <div class="registration_nagivationPart" id="registration_nagivationPart2">
        <div class="registration_nagivationNo">
          <div class="registration_nagivationNumeric registration_NagivationNumeric_Part2">2</div>
          <div class="registration_nagivationtick registration_Nagivationtick_Part2"><img src="assets\images\greentick.png" alt=""></div>
        </div>
        <div class="registration_nagivationName">{{'progresslabel.businessDetails' | cxTranslate}}</div>
      </div>
      <div class="registration_nagivationPart" id="registration_nagivationPart3">
        <div class="registration_nagivationNo">
          <div class="registration_nagivationNumeric registration_NagivationNumeric_Part3">3</div>
          <div class="registration_nagivationtick registration_Nagivationtick_Part3"><img src="assets\images\greentick.png" alt=""></div>
        </div>
        <div class="registration_nagivationName">{{'progresslabel.contactAddress' | cxTranslate}}<ul>
          <li class="billing_Info_Li">{{'progresslabel.billinginformation' | cxTranslate}}</li>
          <li class="payment_Info_Li">{{'progresslabel.payingInformation' | cxTranslate}}</li>
          <li class="shiiping_Location_Li">{{'progresslabel.shippingLocation' | cxTranslate}}</li>
        </ul>
      </div>
    </div>
    <div class="registration_nagivationPart" id="registration_nagivationPart4">
      <div class="registration_nagivationNo">
        <div class="registration_nagivationNumeric">4</div>
        <div class="registration_nagivationtick registration_Nagivationtick_Part4"><img src="assets\images\greentick.png" alt=""></div>
      </div>
      <div class="registration_nagivationName active">{{'progresslabel.reviewConfirm' | cxTranslate}}</div>
    </div>
  </div>
</div>
<div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 registration_rightside no-padding-left">
  <div class=" registration_help">
    {{'bussinessDetails.Havingtrouble' | cxTranslate}} &nbsp;<a routerLink="/help-and-faq"  class="showPopupclick"><span>{{'bussinessDetails.WeCanHelp' | cxTranslate}}</span><span class="global_blackarrow"></span></a>
  </div>
  <section class="registration_review registrationFlow" id="registration_section5">
    <form id="reviewForm" novalidate="novalidate" data-gtm-vis-recent-on-screen55327271_215="1160805" data-gtm-vis-first-on-screen55327271_215="1160805" data-gtm-vis-total-visible-time55327271_215="100" data-gtm-vis-has-fired55327271_215="1">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding-left registration_label padding-B10">{{"reviewpage.title" | cxTranslate}}</div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding-left registration_text1 padding-B20">{{"reviewpage.message" | cxTranslate}}</div>
      <div class="clearboth"></div>
      <div class="registration_reviewContainer">
        @if (userDatadetail) {
          <div class="registration_reviewProfile padding-B20">
            <div class="registration_reviewlabel1">{{"reviewpage.profile" | cxTranslate}}</div>
            <div class="clearboth"></div>
            <div class="registration_reviewlabel2">{{"reviewpage.logininfo" | cxTranslate}}</div>
            <div class="registration_populate registration_reviewemail1">{{userDatadetail.email}}</div>
            <div class="registration_populate registration_reviewpassword" id="reviewLoginPassword">***********</div>
            <div class="registration_reviewlabel2 margin-T25 ">{{"Shippinglocations.ContactInformation" | cxTranslate}}</div>
            <div class="registration_populate registration_reviewname" id="reviewName">{{userDatadetail.firstName}}&nbsp;{{userDatadetail.lastName}}</div>
            <div class="registration_populate registration_reviewBuyer" id="reviewJob">{{userDatadetail.jobTitle}}</div>
            <div class="registration_populate registration_reviewemail" id="reviewContactEmail">{{userDatadetail.email}}</div>
            <div class="registration_populate registration_reviewPh reviewcdcphonehead">
              <div id="reviewPhone">{{userDatadetail.phone}}</div>
              <div class="reviewcdcphone">{{"formLevel.phnext" | cxTranslate}}</div>
              <div class="reviewcdcphone" id="reviewPhoneext">{{userDatadetail.phoneExt}}</div>
            </div>
          </div>
        }
        @if (formDataBussiness) {
          <div class="registration_reviewBusiness padding-B20">
            <div class="registration_reviewparent">
              <div class="registration_reviewlabel1">{{'progresslabel.businessDetails' | cxTranslate}}</div>
              <div class="registration_edit" id="registration_Businessedit" (click)="showBussinessSection()">{{"Shippinglocations.Edit" | cxTranslate}} <i class="fa fa-pencil-square-o" aria-hidden="true"></i></div>
              <div class="clearboth"></div>
            </div>
            <div class="registration_reviewlabel2 ">{{"reviewpage.companyinfo" | cxTranslate}}</div>
            <div class="registration_populate registration_companyName" id="review-orgname">{{ formDataBussiness.orgName}}</div>
            <div class="registration_populate registration_duns" id="review-duns"></div>
            <div class="registration_populate registration_membership" id="registration_membership"></div><!-- Membership for registration changes -->
            <div class="registration_populate registration_gln" id="registration_gln">{{formDataBussiness.globalLocationNumber}}</div>
            <div class="registration_reviewlabel2 margin-T25">{{"Shippinglocations.Address" | cxTranslate}}</div>
            <div class="registration_populate registration_reviewaddress1" id="review-bussiness-address1">{{formDataBussiness.line1}}</div>
            <div class="registration_populate registration_reviewaddress2" id="review-bussiness-address2">{{formDataBussiness.line2}}</div>
            <div class="registration_populate registration_reviewaddress3" id="review-bussiness-city-zip">{{formDataBussiness.city}}, {{formDataBussiness.state}} {{formDataBussiness.postalCode}}</div>
            @if(isPreBook){
            <div class="registration_reviewlabel2 registration_reviewCheckbox margin-T25 auto_roll_review" >
              <label class="checkbox-button registration_ReviewCheckbox_Button">
                <input
                  type="checkbox"
                  class="registration_checkbox"
                  [checked]="orgAddress.get('ARRconsent')?.value"
                  [disabled]="true"
                  >
                  <span class="checkbox-button__control"></span>
                </label>
                <label class="registration_checkboxLabel">{{"reviewpage.arrlabel" | cxTranslate}}</label>
                <div class="enrollment-status" [ngClass]="{'enrolled': orgAddress.get('ARRconsent')?.value,'not-enrolled': !orgAddress.get('ARRconsent')?.value}">
                  {{ orgAddress.get('ARRconsent')?.value ? 'Enrolled' : 'Not enrolled' }}
                </div>
                <div class="clearboth"></div>
              </div>
            }
            </div>
          }
        </div>
        <div class="registration_reviewContainer">
          @if (formDataBilling) {
            <div class="registration_reviewBilling padding-B20">
              <div class="registration_reviewparent">
                <div class="registration_reviewlabel1">{{"reviewpage.billingdetails" | cxTranslate}}</div>
                <div class="registration_edit" id="registration_Billingedit" (click)="showBillingSection()">{{"Shippinglocations.Edit" | cxTranslate}} <i class="fa fa-pencil-square-o" aria-hidden="true"></i></div>
                <div class="clearboth"></div>
              </div>
              <div class="registration_reviewlabel2">{{"Shippinglocations.ContactInformation" | cxTranslate}}</div>
              <div class="registration_populate registration_reviewname" id="review-billing-name">{{formDataBilling.firstName}}&nbsp;{{formDataBilling.lastName}}</div>
              <div class="registration_populate registration_reviewemail" id="review-billing-email">{{formDataBilling.email}}</div>
              <div class="registration_populate registration_reviewPh" id="review-billing-phone">{{formDataBilling.phone}} ext.{{formDataBilling.phoneExt}} </div>
              <div class="registration_reviewlabel2 margin-T25">{{"Shippinglocations.Address" | cxTranslate}}</div>
              <div class="registration_populate registration_reviewaddress1" id="review-billing-address1">{{formDataBilling.line1}}</div>
              <div class="registration_populate registration_reviewaddress2" id="review-billing-address2">{{formDataBilling.line2}}</div>
              <div class="registration_populate registration_reviewaddress3" id="review-billing-city-zip">{{formDataBilling.city}}, {{formDataBilling.state}} {{formDataBilling.postalCode}}</div>
              <div class="registration_reviewlabel2 registration_reviewCheckbox margin-T25">
                @if (formDataBilling?.invoiceEmail) {
                  <label class="checkbox-button">
                    <input type="checkbox" class="registration_checkbox" formControlName="optNotifyInvoiceEmail"  value="true"  [checked]="true"  >
                    <span class="checkbox-button__control"></span>
                  </label>
                } @else {
                  @if (formDataBilling?.invoiceEmail) {
                    <label class="checkbox-button">
                      <input type="checkbox" class="registration_checkbox" formControlName="optNotifyInvoiceEmail"  [checked]="billingAddress.get('optNotifyInvoiceEmail')?.value"  >
                      <span class="checkbox-button__control"></span>
                    </label>
                  } @else {
                    <label class="checkbox-button">
                      <input type="checkbox" class="registration_checkbox" formControlName="optNotifyAcctStmtEmail"  [checked]="billingAddress.get('optNotifyAcctStmtEmail')?.value" />
                      <span class="checkbox-button__control"></span>
                    </label>
                  }
                }
                <label class="registration_checkboxLabel">{{"reviewpage.recieveInvoicebyEmail" | cxTranslate}}</label>
                <div class="clearboth"></div>
              </div>
              <div class="registration_populate registration_reviewemail" id="review-billing-invoice-email">{{formDataBilling.invoiceEmail}}</div>
              <div class="registration_reviewlabel2 registration_reviewCheckbox margin-T25">
                @if (formDataBilling?.acctStmtEmail) {
                  <label class="checkbox-button">
                    <input type="checkbox" class="registration_checkbox" formControlName="optNotifyAcctStmtEmail" value="true"  [checked]="true" />
                    <span class="checkbox-button__control"></span>
                  </label>
                } @else {
                  <label class="checkbox-button">
                    <input type="checkbox" class="registration_checkbox" formControlName="optNotifyAcctStmtEmail"  [checked]="billingAddress.get('optNotifyAcctStmtEmail')?.value" />
                    <span class="checkbox-button__control"></span>
                  </label>
                }
                <label class="registration_checkboxLabel">{{"reviewpage.recieveAccStmntbyEmail" | cxTranslate}}</label>
                <div class="clearboth"></div>
              </div>
              <div class="registration_populate registration_reviewemail" id="review-billing-account-email">{{formDataBilling.acctStmtEmail}}</div>
            </div>
          }
          @if (formDataPaying) {
            <div class="registration_reviewpaying padding-B20">
              <div class="registration_reviewparent">
                <div class="registration_reviewlabel1">{{"reviewpage.payingdetails" | cxTranslate}}</div>
                <div class="registration_edit" id="registration_Payingedit" (click)="showPayingSection()">{{"Shippinglocations.Edit" | cxTranslate}} <i class="fa fa-pencil-square-o" aria-hidden="true"></i></div>
                <div class="clearboth"></div>
              </div>
              <div class="registration_reviewlabel2">{{"Shippinglocations.ContactInformation" | cxTranslate}}</div>
              <div class="registration_populate registration_reviewname" id="review-paying-name">{{formDataPaying.firstName}}&nbsp;{{formDataPaying.lastName}}</div>
              <div class="registration_populate registration_reviewemail" id="review-paying-email">{{formDataPaying.email}}</div>
              <div class="registration_populate registration_reviewPh" id="review-paying-phone">{{formDataPaying.phone}} ext. {{formDataPaying.phoneExt}} </div>
              <div class="registration_reviewlabel2 margin-T25">{{"Shippinglocations.Address" | cxTranslate}}</div>
              <div class="registration_populate registration_reviewaddress1" id="review-paying-adrress1">{{formDataPaying.line1}}</div>
              <div class="registration_populate registration_reviewaddress2" id="review-paying-adrress2">{{formDataPaying.line2}}</div>
              <div class="registration_populate registration_reviewaddress3" id="review-paying-city-zip">{{formDataPaying.city}}, {{formDataPaying.state}} {{formDataPaying.postalCode}}</div>
            </div>
          }
        </div>
        <div class="registration_reviewShipping margin-B20">
          <div class="registration_reviewparent">
            <div class="registration_reviewlabel1">{{"Shippinglocations.ShippingLocations" | cxTranslate}}</div>
            <div class="registration_edit" id="registration_Shippingedit" (click)="showShippingSection()">{{"Shippinglocations.Edit" | cxTranslate}} <i class="fa fa-pencil-square-o" aria-hidden="true"></i></div>
            <div class="clearboth"></div>
          </div>
          <div class="registration_reviewlabel2"><span class="total_ship_location">{{submissionCount}}</span> shipping locations</div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding margin-T20 margin-B20 registration_button">
          <div class="registration_back active" (click)="showShippingSection()">
            <div class="global_blackarrow"></div>
            <span>{{"formLevel.Back" | cxTranslate}}</span>
            <div class="clearboth"></div>
          </div>
          <button class="registration_createAccount active" (click)="createAccount()" type="submit">{{"reviewpage.createAccount" | cxTranslate}}</button>
          <div class="clearboth"></div>
        </div>
      </form>
    </section>
  </div>
</div>
<!------Review Page section Ends here------>
}
